import { render, staticRenderFns } from "./ShopAuthorizeView.vue?vue&type=template&id=189f5182&"
import script from "./ShopAuthorizeView.vue?vue&type=script&lang=js&"
export * from "./ShopAuthorizeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports